import { useNavigate } from "react-router-dom";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { getTrackCoverUrl, handleImageError } from "@/utils/trackCoverUtils";
import { AudioLines } from "lucide-react";

interface VisitorPreviewLimitDialogProps {
  open: boolean;
  onDismiss: () => void;
  trackTitle?: string;
  artistName?: string;
  coverUrl?: string;
}

export default function VisitorPreviewLimitDialog({
  open,
  onDismiss,
  trackTitle,
  artistName,
  coverUrl,
}: VisitorPreviewLimitDialogProps) {
  const navigate = useNavigate();
  const resolvedCover = getTrackCoverUrl(coverUrl, "medium");

  const handleCreateAccount = () => {
    onDismiss();
    navigate("/register/fan");
  };

  return (
    <Dialog open={open} onOpenChange={(v) => !v && onDismiss()}>
      <DialogContent
        className="light font-archivo max-w-[400px] gap-0 overflow-hidden rounded-[3px] sm:rounded-[3px] border border-[#1E1B4B]/[0.12] bg-white p-0 text-center"
        hideCloseButton
      >
        <div className="px-7 pb-6 pt-8">
          <div className="mx-auto h-40 w-40 rounded-[3px] overflow-hidden bg-[#EFEFF7]">
            <img
              src={resolvedCover}
              alt={trackTitle ?? "Track cover"}
              className="w-full h-full object-cover"
              onError={handleImageError}
            />
          </div>
          <div className="mt-[18px] flex items-center justify-center gap-2 font-archivo text-[19px] font-bold leading-tight text-[#1E1B4B]">
            <AudioLines className="h-[17px] w-[17px] shrink-0 text-[#5A31D8]" strokeWidth={1.8} />
            {trackTitle ?? "Preview Ended"}
          </div>
          {artistName && (
            <p className="mt-[7px] font-archivo text-sm text-[#6E6B8A]">
              {artistName}
            </p>
          )}
          <p className="mx-auto mt-3.5 max-w-[42ch] font-archivo text-sm leading-relaxed text-[#4A4770]">
            Your 29-second preview has ended. Create a free fan account so
            your streams count and support your favorite artists.
          </p>
          <div className="mt-[22px] flex flex-col gap-[9px]">
            <button
              type="button"
              onClick={handleCreateAccount}
              className="rounded-[2px] bg-[#5A31D8] py-4 font-archivo text-sm font-bold text-white"
            >
              Create fan account
            </button>
            <button
              type="button"
              onClick={onDismiss}
              className="rounded-[2px] py-3.5 font-archivo text-sm font-medium text-[#6E6B8A]"
            >
              Maybe later
            </button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
